//封装aip请求信息
import axios from 'axios';
import {Message} from 'element-ui';
import qs from "qs";
import process from "shelljs";

//axios.defaults.baseURL = process.env.BASE_API; /*跨域*/
axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.headers.post['token'] = localStorage.getItem("token");

/* 自定义响应拦截器 */
axios.interceptors.response.use(res => {
  // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403, res 是所有相应的信息
  console.log(res);
  return Promise.resolve(res);
  // if (res.data['code'] === 0) {
  //   return Promise.resolve(res)
  // } else {
  //   Message.error(res.data['message'])
  // }
},error => {
  if (error.response) {
    console.log(error.response);
    Message.error(error.response.data.msg); // 弹出错误提示
    /*Object.keys(urls.errors).forEach(key => {
     if (error.response.status === key) {  // 遍历key
     Message.error(urls.errors[key]) // 弹出错误提示
     }
     })*/
    return Promise.reject(false);
  }
  return Promise.reject(error);
});

export const get = (url,params) => {
  console.log(url + qs.stringify(params));
  return axios.get(url + qs.stringify(params),{
    timeout:6000
  });
};

export const post = (url,params,headers = {}) => {
  console.log(url);
  return axios({
    method:'post',url:url,data:JSON.stringify(params),headers:headers,timeout:6000
  });
};



// WEBPACK FOOTER //
// ./src/utils/api.js